/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { Color, LayerMaterial, Noise } from "lamina";

export default function ContactScene({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF("./models/Comms.glb");
  return (
    <group ref={group} {...props} dispose={null} scale={60}>
      <group rotation={[-Math.PI, 0, Math.PI]}>
        <mesh
          geometry={nodes.Mesh_desk_computerScreen_1.geometry}
          material={materials.metal}
        />
        <mesh
          geometry={nodes.Mesh_desk_computerScreen_2.geometry}
          material={materials.dark}
        />
        <mesh
          geometry={nodes.Mesh_desk_computerScreen_3.geometry}
          material={materials.metalDark}
        />
      </group>
      <group position={[-0.33, 0, 0.36]} rotation={[0, Math.PI / 3, 0]}>
        <mesh
          geometry={nodes.Mesh_desk_chair_1.geometry}
          material={materials["metal 1"]}
        >
          <LayerMaterial>
            <Color color="blue" alpha={1} mode="normal" />
            <Noise type="simplex" />
          </LayerMaterial>
        </mesh>
        <mesh
          geometry={nodes.Mesh_desk_chair_2.geometry}
          material={materials.metalRed}
        />
        <mesh
          geometry={nodes.Mesh_desk_chair_3.geometry}
          material={materials["metalDark 1"]}
        />
      </group>
      <group
        position={[0.28, 0, -9.51]}
        rotation={[-Math.PI, -Math.PI / 6, -Math.PI]}
        scale={5}
      >
        <mesh
          geometry={nodes.Mesh_satelliteDish_detailed_1.geometry}
          material={materials["metal 2"]}
        />
        <mesh
          geometry={nodes.Mesh_satelliteDish_detailed_2.geometry}
          material={materials["metalDark 2"]}
        />
        <mesh
          geometry={nodes.Mesh_satelliteDish_detailed_3.geometry}
          material={materials._defaultMat}
        />
        <mesh
          geometry={nodes.Mesh_satelliteDish_detailed_4.geometry}
          material={materials["metalRed 1"]}
        />
        <mesh
          geometry={nodes.Mesh_satelliteDish_detailed_5.geometry}
          material={materials["dark 1"]}
        />
      </group>
      <group position={[0.5261, 0, -0.0792]} rotation={[-Math.PI, 0, -Math.PI]}>
        <mesh
          geometry={nodes.Mesh_cable.geometry}
          material={materials["dark 2"]}
          position={[-0.4, 0, 0.025]}
        />
        <mesh
          geometry={nodes.Mesh_machine_generator_1.geometry}
          material={materials["metalDark 3"]}
        />
        <mesh
          geometry={nodes.Mesh_machine_generator_2.geometry}
          material={materials["metalRed 2"]}
        />
        <mesh
          geometry={nodes.Mesh_machine_generator_3.geometry}
          material={materials["metal 3"]}
        />
        <mesh
          geometry={nodes.Mesh_machine_generator_4.geometry}
          material={materials["_defaultMat 1"]}
        />
      </group>
      <pointLight
        intensity={1}
        decay={2}
        distance={10000}
        position={[-0.07, 0.37, 0.82]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
      <pointLight
        intensity={1}
        decay={2}
        distance={10000}
        position={[0.06, 0.53, 0.2]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
      <pointLight
        intensity={1}
        decay={2}
        distance={10000}
        position={[0.83, 0.65, 0.43]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
      <pointLight
        intensity={1}
        decay={2}
        distance={20000}
        position={[1.09, 3.16, -8.12]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
      <pointLight
        intensity={1}
        decay={2}
        distance={20000}
        position={[1.09, 2.64, -10.1]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
      <pointLight
        intensity={1}
        decay={2}
        distance={20000}
        position={[1.09, 1.2, -8.1]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.001}
      />
    </group>
  );
}

useGLTF.preload("./models/Comms.glb");
